(function($) {
	jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
	    // code to be trigger when confirmation page is loaded
    	$(".Modal-tco_list--bar").addClass('Modal-tco_list--bar_animate');
    	$(".HeroHeader-modal_tco_list--item").addClass('HeroHeader-modal_tco_list--item_animate');
        $('.HeroHeader-modal--text p').addClass('hide');
	});
}(jQuery));
